import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";
import rootReducer from "./reducer/reducer-root";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import thunkMiddleware from "redux-thunk";
import { logger } from "redux-logger";
import { initializeApiClient } from "./services/api-client";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store;
if (process.env.REACT_APP_MODE === "Dev") {
    store = createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(logger, thunkMiddleware))
    );
} else {
    store = createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(thunkMiddleware))
    );
}

// Initialize API client with Redux store
initializeApiClient(store);

const persist = persistStore(store);

// Global error handler for unhandled errors
window.addEventListener('error', (event) => {
    import('./utils/errorLogger').then(({ default: errorLogger }) => {
        errorLogger.error('Unhandled JavaScript error', event.error, {
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno
        });
    });
});

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
    import('./utils/errorLogger').then(({ default: errorLogger }) => {
        errorLogger.error('Unhandled promise rejection', event.reason, {
            type: 'PromiseRejection'
        });
    });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <PersistGate persistor={persist}>
            <App />
        </PersistGate>
    </Provider>
);

reportWebVitals();